import { xget, xhttp } from "../Fetchv2.js";
import { MGSchema } from "../schemas/mg.schema.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class EmailActivity {
	/** @GET /pages/:uid/email_activity
	 * Obtiene todas las actividades de correo de la página
	 */
	async getAllEmailActivities(pgid: string, params: { take?: number; skip?: number }, token: string) {
		let p = { params: btoa(JSON.stringify(params)) };
		let response = await xget<{ email_activities: PGSchema.email_activity[] }>(`/pages/${pgid}/email_activity`, { params: p }, { headers: { "app-token": token } });
		return response;
	}

	/** @GET /pages/:uid/email_activity/:id
	 * Obtiene una actividad de correo específica
	 */
	async getEmailActivity(pgid: string, id: string, token: string) {
		let response = await xget<{ email_activity: PGSchema.email_activity; deatils: MGSchema.SNS }>(`/pages/${pgid}/email_activity/${id}`, {}, { headers: { "app-token": token } });
		return response;
	}

	/** @DELETE /pages/:uid/email_activity/:id
	 * Borra una actividad de correo
	 */
	async deleteEmailActivity(pgid: string, id: string, token: string) {
		let response = await xhttp<{ deleted: PGSchema.email_activity }>(`/pages/${pgid}/email_activity/${id}`, "DELETE", {}, { headers: { "app-token": token } });
		return response;
	}
}
